import { faCartShopping } from '@fortawesome/free-solid-svg-icons'
import React, { useCallback } from 'react'
import { NotificationProps } from '../../FactoryNotification/FactoryNotification'
import GenericNotification from '../GenericNotification'


interface NewProductProposalNotificationProps extends NotificationProps{
	item: {
		id: string, 
		notifMsg: string, 
		timestamp: number, 
		viewed: boolean,
		notifData: {
			approved: string, 
			receivedFromType: string, 
            userName: string,
            transactionId: string
		},
	}
}


const NewProductProposalNotification = ({ item, clickable, onSetNotificationAsView }: NewProductProposalNotificationProps) => {
	const { id, timestamp, viewed, notifData: { approved } } = item

	const touchNotification =  useCallback(
	  () => {
        if(!viewed)
            onSetNotificationAsView(id)
	  },
	  [],
	)
	
	return(
		<GenericNotification 
			touchNotification={touchNotification} 
			

			id={id}
			timestamp={timestamp}
			viewed={clickable ? viewed : true}
			description={"New product proposal"}
			title={"Username wants to share a product with you"}

			icon={ faCartShopping }
			color={ "#5d5d5d" }
		/>
	)
}

export default React.memo( NewProductProposalNotification )